import EmbedWrapper from "./EmbedWrapper"

export default EmbedWrapper
